"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _debug = _interopRequireDefault(require("debug"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable class-methods-use-this */
var BASE = 'TRS';
var COLOURS = {
  info: '#111e6c',
  warn: '#FDD400',
  error: '#d90000'
};
var environment = typeof process !== 'undefined' && process.env ? process.env.NODE_ENV : undefined;
var Log = /*#__PURE__*/_createClass(function Log() {
  var _this = this;
  _classCallCheck(this, Log);
  _defineProperty(this, "startGroup", function (name) {
    return _this.group(name);
  });
  _defineProperty(this, "groupEnd", function () {
    return window.console.groupEnd();
  });
  _defineProperty(this, "generateMessage", function (level, message, source) {
    var namespace = "".concat(BASE, ":").concat(level);
    var createDebug = (0, _debug["default"])(namespace);
    createDebug.color = COLOURS[level];
    if (source) {
      createDebug(source, message);
    } else {
      createDebug(message);
    }
  });
  _defineProperty(this, "info", function (message, source) {
    return _this.generateMessage('info', message, source);
  });
  _defineProperty(this, "warn", function (message, source) {
    return _this.generateMessage('warn', message, source);
  });
  _defineProperty(this, "error", function (message, source) {
    return _this.generateMessage('error', message, source);
  });
  if (!localStorage.getItem('debug') && environment === 'development') {
    localStorage.setItem('debug', "".concat(BASE, ":*"));
  }
  this.group = window.console.groupCollapsed || window.console.group;
});
var _default = exports["default"] = new Log();